import PropTypes from "prop-types";
import React from "react";
import { frenchMonth } from "../../../../variables/functions";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import { DocumentFooter } from "../../../../components/docs/DocumentFooter";
import DocumentHeader from "../../../../components/docs/DocumentHeader";

const EtatChequesEmis = React.forwardRef((props, ref) => {
    const { periode, rows = [], totalMontant = 0 } = props;

    return (
        <div
            className="col-12"
            style={{
                width: "210mm",
                height: "297mm",
                margin: 0,
                padding: 0,
                pageBreakInside: "avoid",
                fontFamily: "'Times New Roman', Times, serif"
            }}
            ref={ref}
        >
            <div
                className="card"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "297mm",
                    position: "relative"
                }}
            >
                <DocumentHeader typeOrganisme={"POOL"} />

                <div
                    style={{
                        padding: "5mm",
                        boxSizing: "border-box",
                        flex: "1"
                    }}
                >
                    <div className="row">
                        <div className="col-12">
                            <table className="table table-bordered" style={{ width: "55%" }}>
                                <tbody>
                                    <tr style={{ lineHeight: "1" }}>
                                        <td className="text-left">
                                            <strong>ÉTAT DES CHÈQUES ÉMIS PAR LES COMPAGNIES</strong>
                                        </td>
                                    </tr>
                                    <tr style={{ lineHeight: "1" }}>
                                        <td className="text-left">
                                            <em>
                                                <strong>
                                                    Période : {frenchMonth(periode?.split("-")?.[1])} {periode?.split("-")?.[0]}
                                                </strong>
                                            </em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-12">
                            <table className="table table-bordered" style={{ width: "100%" }}>
                                <thead>
                                    <tr style={{ lineHeight: "1" }}>
                                        <th className="text-center" style={{ width: "5%" }}>N°</th>
                                        <th>Compagnie</th>
                                        <th className="text-center" style={{ width: "10%" }}>Catégorie</th>
                                        <th>N° Chèque</th>
                                        <th>Banque</th>
                                        <th className="text-end" style={{ width: "18%" }}>Montant (F CFA)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.length === 0 ? (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                <em>Aucune donnée pour cette période</em>
                                            </td>
                                        </tr>
                                    ) : (
                                        rows.map((row, idx) => (
                                            <tr key={row.key} style={{ lineHeight: "1" }}>
                                                <td className="text-center">{idx + 1}</td>
                                                <td>
                                                    <strong>{row.compagnie}</strong>
                                                </td>
                                                <td className="text-center">{row.categorie || "—"}</td>
                                                <td>{row.numeroCheque || "—"}</td>
                                                <td>{row.banque || "—"}</td>
                                                <td className="text-end">
                                                    {displayNumbers(row.montantCheque || 0)}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr style={{ lineHeight: "1" }}>
                                        <th colSpan={5} className="text-end">TOTAL</th>
                                        <th className="text-end">
                                            {displayNumbers(totalMontant || 0)}
                                        </th>
                                    </tr>
                                </tfoot>
                            </table>

                            <br />

                            <div style={{ marginLeft: "500px" }}>
                                <div className="row">
                                    <div className="col-12">
                                        <u><strong>Directeur du Pool</strong></u>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <div className="col-12">
                                        <strong>Koffi G. WARBUTIN</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DocumentFooter
                    style={{
                        width: "100%",
                        marginTop: "auto"
                    }}
                />
            </div>
        </div>
    );
});

EtatChequesEmis.displayName = "EtatChequesEmis";

EtatChequesEmis.propTypes = {
    periode: PropTypes.string,
    rows: PropTypes.array,
    totalMontant: PropTypes.number,
};

export default EtatChequesEmis;
